export default [
    function () {
        return {
            require: 'ngInclude',
            restrict: 'A',
            link(scope, el, attrs) {
                el.replaceWith(el.children());
            },
        };
    },
];
